import { render, staticRenderFns } from "./LKPublicationsFormdataTableHeader.vue?vue&type=template&id=274d95fe&"
import script from "./LKPublicationsFormdataTableHeader.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports